import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FlashcardDetail from '../components/Flashcards/FlashcardDetail';

const FlashcardDetailPage = () => {
  const { id } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <main className="pt-16">
        <section className="py-16 bg-white">
          <FlashcardDetail id={id} />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default FlashcardDetailPage;